/**
 * @function getSsoConfiguration
 *
 * This function is used to unwrap and construct the sso configuration when given the GraphQL data.
 *
 * @param {object} gdData - The data received from a GraphQL User.GoodDataClaim Query.
 *
 * @return {object} - An object representing the sso configuration.
 * Provides you the loginUrl, the encyptedClaims, and the ssoProvider.
 *
 * @example
 *
 *     getSsoConfiguration(gdGQLData)
 */
export const getSsoConfiguration = (gdData: any) => {
  const base64Encoded =
    (gdData && gdData.user.goodDataClaim.base64Encoded) || false;
  const loginUrl = (gdData && gdData.user.goodDataClaim.loginUrl) || "";
  const encryptedClaims =
    (base64Encoded &&
      gdData &&
      atob(gdData.user.goodDataClaim.encryptedClaims)) ||
    (!base64Encoded && gdData && gdData.user.goodDataClaim.encryptedClaims) ||
    "";
  const ssoProvider = (gdData && gdData.user.goodDataClaim.ssoProvider) || "";

  return {
    loginUrl,
    encryptedClaims,
    ssoProvider
  };
};
try {
    // @ts-ignore
    getSsoConfiguration.displayName = "getSsoConfiguration";
    // @ts-ignore
    getSsoConfiguration.__docgenInfo = { "description": "", "displayName": "getSsoConfiguration", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/utilities/getSsoConfiguration.ts#getSsoConfiguration"] = { docgenInfo: getSsoConfiguration.__docgenInfo, name: "getSsoConfiguration", path: "src/shared/containers/GoodData/utilities/getSsoConfiguration.ts#getSsoConfiguration" };
}
catch (__react_docgen_typescript_loader_error) { }